import { includes } from "lodash";

const imageExtensions = ["jpg", "jpeg", "png", "gif", "tiff", "bmp"];

const getUrlExtension = url => {
  return url
    .split(/#|\?/)[0]
    .split(".")
    .pop()
    .trim()
    .toLowerCase();
};

export default url => includes(imageExtensions, getUrlExtension(url));
